import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { presentValidator } from '../../../shared/validators/present';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientsService } from '../../../core/services/clients.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-client-deactivate-modal',
  templateUrl: './client-deactivate-modal.component.html',
  imports: [FaIconComponent, FormsModule, ReactiveFormsModule, MatProgressSpinner ]
})
export class DeactivateClientModalComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private clientsService = inject(ClientsService);

  @Input() clientId!: number;

  errorMessage: string | null = null;
  submitting = false;
  note: FormControl;

  ngOnInit() {
    this.note = new FormControl('', presentValidator());
  }

  onCloseClick(): void {
    this.activeModal.dismiss('cancel');
  }

  onSubmit(event: Event): void {
    event.preventDefault();

    if (this.submitting || this.note.invalid) {
      return;
    }

    this.submitting = true;
    this.errorMessage = null;

    const reason = this.note.value;

    this.clientsService.deactivate(this.clientId, reason).subscribe({
      next: (client) => {
        this.submitting = false;
        this.activeModal.close({ client: client });
      },
      error: (err) => {
        this.submitting = false;
        this.errorMessage =
          err?.error?.message || 'There was a problem deactivating this client.';
      }
    });
  }
}
